import React from 'react';
import './About.scss';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import logoPatte from '../../assets/img/logo-patte-removebg-preview.png';
import avisUn from '../../assets/img/avis1.png';
import avisDeux from '../../assets/img/avis2.png';
import avisTrois from '../../assets/img/avis3.png';
import avisQuatre from '../../assets/img/avis4.png';
import heartImg from '../../assets/img/heart-img.png';
import starImg from '../../assets/img/star-img.png';


function About() {

    return (

        <main className="about">
            <div className="about-background">
                <div className="about-background__container-title">
                    <p className="about-background__title">La Truffe à 4 Pattes</p>
                    <img className="about-background__logo" src={logoPatte} alt="Logo" />
                </div>
            </div>

            <section className="who-am-i">
                <h1 className='who-am-i__title'>Qui suis-je ?</h1>
                <div className="flex">
                    <img className="who-am-i__heart-img" src={heartImg} alt="Coeur" />
                    <div className='who-am-i__container-text'>
                        <p className="who-am-i__text">
                            Je suis Séverine, une passionnée des animaux depuis ma plus tendre enfance.
                        </p>
                        <p className="who-am-i__text">
                            À l'âge de 46 ans, j'ai décidé de donner un nouvel élan à ma carrière en me lançant dans la profession de coach en éducation canine et pet-sitter.
                        </p>
                        <p className="who-am-i__text">
                            En octobre 2021, j'ai obtenu avec succès l'ACACED, et j'ai également décroché le diplôme de connaissance et compétence animalière délivré par le Centre Européen de Formation en février 2022. Je continue de me perfectionner avec les formations en ligne proposées par Esprit Dog.                        </p>
                        <p className="who-am-i__text">
                            Mon amour pour les animaux ne cesse de grandir, et c'est grâce à de nombreuses expériences et stages enrichissants que j'ai décidé de créer La Truffe À 4 Pattes.
                        </p>
                        <p className="who-am-i__text">
                            Cette aventure est inspirée par mes quatre adorables chats et par Shadow, mon fidèle compagnon à quatre pattes.
                        </p>
                        <p className="who-am-i__text">
                            Chez La Truffe À 4 Pattes, je mets en œuvre toute mon expertise et ma passion pour assurer le bien-être et l'épanouissement de vos précieux compagnons.
                        </p>
                    </div>
                </div>
                <div className="liner"></div>
            </section>

            <section className="values">
                <h2 className="values__title">Mes Valeurs</h2>
                <div className="flex">
                    <img className='values__star-img' src={starImg} alt='Etoile' />
                    <div className="values__content-text">
                        <p className="values__text">
                            <strong>1. Bien-être de l'Animal :</strong> Le respect et le bien-être de chaque animal sont au cœur de ma pratique. Je privilégie une approche douce et respectueuse, sans recours à la force ou à l'intimidation.
                        </p>
                        <p className="values__text">
                            <strong>2. Méthode Adaptative :</strong> Je crois qu'il n'y a pas une méthode unique pour tous. Chaque animal a sa personnalité et j'adapte ma méthode pour répondre à ses besoins spécifiques.
                        </p>
                        <p className="values__text">
                            <strong>3. Écoute de vos Besoins :</strong> Comprendre vos attentes et celles de votre compagnon est essentiel pour moi. Cela me permet de fournir un service personnalisé et efficace.
                        </p>
                        <p className="values__text">
                            <strong>4. Communication :</strong> La communication claire et bienveillante est la clé. Je m'efforce de créer un environnement positif où l'animal se sent motivé et heureux d'apprendre.
                        </p>
                        <p className="values__text">
                            <strong>5. Transmission de Connaissance :</strong> Mon objectif est de vous transmettre les compétences nécessaires pour comprendre et interagir harmonieusement avec votre animal, assurant ainsi une relation durable et enrichissante.
                        </p>
                    </div>
                </div>
                <div className="liner"></div>
            </section>

            <section className="testimonials">
                <h2 className="testimonials__title">Témoignages</h2>
                <div className="testimonials__carousel-container">
                    <Carousel
                        showArrows={true}
                        infiniteLoop={true}
                        showThumbs={false}
                        showStatus={false}
                    // autoPlay={true}
                    // interval={3000}
                    >
                        <div>
                            <img className="testimonials__img-avis" src={avisUn} alt="Avis" />
                        </div>
                        <div>
                            <img className="testimonials__img-avis" src={avisDeux} alt="Avis" />
                        </div>
                        <div>
                            <img className="testimonials__img-avis" src={avisTrois} alt="Avis" />
                        </div>
                        <div>
                            <img className="testimonials__img-avis" src={avisQuatre} alt="Avis" />
                        </div>
                    </Carousel>
                </div>

                <div className="more-testimonials">
                    <a className='more-testimonials__link'
                        href="https://www.google.com/search?sca_esv=584316335&rlz=1C1GCEA_enFR1080FR1080&sxsrf=AM9HkKkaqTSzzJBT3ip9ZKEW-269XC9Rtg:1700582368086&q=la+truffe+a+4+pattes&spell=1&sa=X&sqi=2&ved=2ahUKEwjO6df_utWCAxWwRaQEHe2nB7MQBSgAegQICBAC&biw=2048&bih=839&dpr=1" target="_blank" rel="noopener noreferrer">
                        Plus d'avis ? Vous pouvez consulter les avis de mes clients sur Google.
                    </a>
                </div>
            </section>
        </main>
    );
}

export default About;

